(() => {
  if (window.KMCActionPackXL) return;
  const names = ['action pack - xl addon', 'decaffeinated action pack - xl addon', 'vegan friendly action pack - xl addon', 'gluten free action pack - xl addon'];
  const normal = value => value.replace(/\s+/g, ' ').trim().toLowerCase();
  const refreshSource = source => {
    const template = document.querySelector('[data-kmc-xl-gelx]');
    if (!template || !source) return;
    const markers = [...source.querySelectorAll('strong,b,h2,h3,h4,h5,h6')].filter(n => !n.closest('a') && /action pack(?: - xl addon)?$/i.test(normal(n.textContent)));
    markers.forEach((marker, index) => {
      if (!names.includes(normal(marker.textContent))) return;
      const range = document.createRange();
      range.setStartAfter(marker);
      const end = markers[index + 1];
      if (end) range.setEndBefore(end); else range.setEnd(source, source.childNodes.length);
      if (normal(marker.textContent) === 'gluten free action pack - xl addon') {
        const group = [...source.querySelectorAll('a')].filter(link => range.intersectsNode(link));
        const pockets = ['kmc-nrg-bar-original-pocket', 'kmc-nrg-bar-brown-kendal-mint-cake-recharged-pocket-sized-energy-bar-42g', 'kmc-nrg-bar-kendal-mint-cake-pocket-sized-energy-bar-raspberry-mint'];
        group.filter(link => pockets.some(handle => new URL(link.href, location.origin).pathname.endsWith('/' + handle))).forEach(link => {
          const quantity = new URL(link.href, location.origin).pathname.endsWith('/kmc-nrg-bar-original-pocket') ? '1x' : '2x';
          link.textContent = link.textContent.replace(/^\s*\d+x/, quantity);
        });
        const white = group.filter(link => new URL(link.href, location.origin).pathname.endsWith('/kmc-nrg-bar-white-chocolate-coated-50g'));
        white.slice(1).forEach(link => link.remove());
      }
      if (normal(marker.textContent) === 'vegan friendly action pack - xl addon') {
        [...source.querySelectorAll('a')].filter(link => range.intersectsNode(link) && /^x\s/i.test(link.textContent.trim()) && /^1x\s/i.test(link.title)).forEach(link => { link.textContent = link.textContent.replace(/^x/, '1x'); });
      }
      const fragment = range.cloneContents();
      if (/\bGEL\s*X\b/i.test(fragment.textContent)) return;
      const links = [...source.querySelectorAll('a')].filter(link => range.intersectsNode(link) && /^\s*\d*x\s/i.test(link.textContent));
      const last = links.at(-1);
      if (last) last.after(template.content.cloneNode(true));
    });
  };
  window.KMCActionPackXL = {refreshSource};
  const boot = () => {
    if (!document.querySelector('[data-kmc-xl-gelx]')) return;
    document.querySelectorAll('.metafield-rich_text_field').forEach(refreshSource);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
